"use client";

import type { Dispatch, ReactElement, SetStateAction } from "react";
import type { GanttLayout } from "./gantt-types";
import { GanttTaskMarker } from "./GanttTaskMarker";

export interface GanttTaskLayerProps {
  ganttIdPrefix: string;
  layout: GanttLayout;
  hoveredTaskId: string | null;
  highlightedTaskIds: ReadonlySet<string>;
  onHoveredTaskIdChange: Dispatch<SetStateAction<string | null>>;
}

export function GanttTaskLayer({
  ganttIdPrefix,
  layout,
  hoveredTaskId,
  highlightedTaskIds,
  onHoveredTaskIdChange,
}: GanttTaskLayerProps): ReactElement {
  return (
    <>
      {layout.taskLayouts.map((taskLayout, rowIndex) => (
        <GanttTaskMarker
          key={`${ganttIdPrefix}-task-${taskLayout.task.id}`}
          ganttIdPrefix={ganttIdPrefix}
          taskLayout={taskLayout}
          rowIndex={rowIndex}
          hoveredTaskId={hoveredTaskId}
          highlightedTaskIds={highlightedTaskIds}
          onHoveredTaskIdChange={onHoveredTaskIdChange}
        />
      ))}
    </>
  );
}
